import axios from 'axios'

const editCurrency = async (formData, id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/editCurrency/${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      }
    )
    console.log('response for edit', response)
    return response.data
  } catch (error) {
    throw error
  }
}

export default editCurrency
